var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveCircleTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.14209 8.49992C0.14209 4.1967 3.63054 0.708252 7.93376 0.708252C12.237 0.708252 15.7254 4.1967 15.7254 8.49992C15.7254 12.8031 12.237 16.2916 7.93376 16.2916C3.63054 16.2916 0.14209 12.8031 0.14209 8.49992Z",
    fill: "#03B675"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6957 5.69702C11.9724 5.97364 11.9724 6.42213 11.6957 6.69876L7.29904 11.3029C7.02242 11.5795 6.57393 11.5795 6.29731 11.3029L4.17231 9.17792C3.89569 8.9013 3.89569 8.45281 4.17231 8.17619C4.44893 7.89957 4.89742 7.89957 5.17404 8.17619L6.79818 9.80032L10.694 5.69702C10.9706 5.4204 11.4191 5.4204 11.6957 5.69702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveCircleTick);
export default __webpack_public_path__ + "static/media/ApproveCircleTick.69f635f60c52c9edf43b72ad0206b263.svg";
export { ForwardRef as ReactComponent };